import { SearchEvent } from '../../apis/event/SearchEvent';

export const EventService = {
  search: async () => {
    return await SearchEvent();
  },
};
